/* eslint-disable */
import { Media, Gradient } from './common.js';

import {
  CardData_ImageScaling_Scaling,
  CardData_ImagePosition_Position,
  CardData_Background_Type,
} from './node_card.enums.js';

/** flynt-disable missing-string-validations */

export interface CardData {
  /** Background styling (color or gradient). */
  background?: CardData_Background;
  /** Background image. */
  backgroundImage?: CardData_BackgroundImage;
}

export interface CardData_ImageScaling {}

export function cardData_ImageScaling_ScalingFromJSON(
  object: any
): CardData_ImageScaling_Scaling {
  switch (object) {
    case 0:
    case "AUTO":
      return CardData_ImageScaling_Scaling.AUTO;
    case 1:
    case "CONTAIN":
      return CardData_ImageScaling_Scaling.CONTAIN;
    case 2:
    case "COVER":
      return CardData_ImageScaling_Scaling.COVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CardData_ImageScaling_Scaling.UNRECOGNIZED;
  }
}

export function cardData_ImageScaling_ScalingToJSON(
  object: CardData_ImageScaling_Scaling
): string {
  switch (object) {
    case CardData_ImageScaling_Scaling.AUTO:
      return "AUTO";
    case CardData_ImageScaling_Scaling.CONTAIN:
      return "CONTAIN";
    case CardData_ImageScaling_Scaling.COVER:
      return "COVER";
    default:
      return "UNKNOWN";
  }
}

export interface CardData_ImagePosition {}

export function cardData_ImagePosition_PositionFromJSON(
  object: any
): CardData_ImagePosition_Position {
  switch (object) {
    case 0:
    case "CENTER":
      return CardData_ImagePosition_Position.CENTER;
    case 1:
    case "CENTER_LEFT":
      return CardData_ImagePosition_Position.CENTER_LEFT;
    case 2:
    case "CENTER_RIGHT":
      return CardData_ImagePosition_Position.CENTER_RIGHT;
    case 3:
    case "TOP":
      return CardData_ImagePosition_Position.TOP;
    case 4:
    case "TOP_LEFT":
      return CardData_ImagePosition_Position.TOP_LEFT;
    case 5:
    case "TOP_RIGHT":
      return CardData_ImagePosition_Position.TOP_RIGHT;
    case 6:
    case "BOTTOM":
      return CardData_ImagePosition_Position.BOTTOM;
    case 7:
    case "BOTTOM_LEFT":
      return CardData_ImagePosition_Position.BOTTOM_LEFT;
    case 8:
    case "BOTTOM_RIGHT":
      return CardData_ImagePosition_Position.BOTTOM_RIGHT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CardData_ImagePosition_Position.UNRECOGNIZED;
  }
}

export function cardData_ImagePosition_PositionToJSON(
  object: CardData_ImagePosition_Position
): string {
  switch (object) {
    case CardData_ImagePosition_Position.CENTER:
      return "CENTER";
    case CardData_ImagePosition_Position.CENTER_LEFT:
      return "CENTER_LEFT";
    case CardData_ImagePosition_Position.CENTER_RIGHT:
      return "CENTER_RIGHT";
    case CardData_ImagePosition_Position.TOP:
      return "TOP";
    case CardData_ImagePosition_Position.TOP_LEFT:
      return "TOP_LEFT";
    case CardData_ImagePosition_Position.TOP_RIGHT:
      return "TOP_RIGHT";
    case CardData_ImagePosition_Position.BOTTOM:
      return "BOTTOM";
    case CardData_ImagePosition_Position.BOTTOM_LEFT:
      return "BOTTOM_LEFT";
    case CardData_ImagePosition_Position.BOTTOM_RIGHT:
      return "BOTTOM_RIGHT";
    default:
      return "UNKNOWN";
  }
}

export interface CardData_BackgroundImage {
  /** Background image. */
  media?: Media;
  /** Background image opacity. */
  opacity?: number;
  /** Background image scaling. */
  scaling: CardData_ImageScaling_Scaling;
  /** Position of background. Defaults to `CENTER`. */
  position: CardData_ImagePosition_Position;
}

/** Background styling (color or gradient) */
export interface CardData_Background {
  /** Background type. */
  type: CardData_Background_Type;
  /** Background color as a hexadecimal value. */
  color?: string;
  /** Gradient configuration. */
  gradient?: Gradient;
}

export function cardData_Background_TypeFromJSON(
  object: any
): CardData_Background_Type {
  switch (object) {
    case 0:
    case "COLOR":
      return CardData_Background_Type.COLOR;
    case 1:
    case "GRADIENT":
      return CardData_Background_Type.GRADIENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CardData_Background_Type.UNRECOGNIZED;
  }
}

export function cardData_Background_TypeToJSON(
  object: CardData_Background_Type
): string {
  switch (object) {
    case CardData_Background_Type.COLOR:
      return "COLOR";
    case CardData_Background_Type.GRADIENT:
      return "GRADIENT";
    default:
      return "UNKNOWN";
  }
}

const baseCardData: object = {};

export const CardData = {
  fromJSON(object: any): CardData {
    const message = { ...baseCardData } as CardData;
    message.background =
      object.background !== undefined && object.background !== null
        ? CardData_Background.fromJSON(object.background)
        : undefined;
    message.backgroundImage =
      object.backgroundImage !== undefined && object.backgroundImage !== null
        ? CardData_BackgroundImage.fromJSON(object.backgroundImage)
        : undefined;
    return message;
  },

  toJSON(message: CardData): unknown {
    const obj: any = {};
    message.background !== undefined &&
      (obj.background = message.background
        ? CardData_Background.toJSON(message.background)
        : undefined);
    message.backgroundImage !== undefined &&
      (obj.backgroundImage = message.backgroundImage
        ? CardData_BackgroundImage.toJSON(message.backgroundImage)
        : undefined);
    return obj;
  },
};

const baseCardData_ImageScaling: object = {};

export const CardData_ImageScaling = {
  fromJSON(_: any): CardData_ImageScaling {
    const message = { ...baseCardData_ImageScaling } as CardData_ImageScaling;
    return message;
  },

  toJSON(_: CardData_ImageScaling): unknown {
    const obj: any = {};
    return obj;
  },
};

const baseCardData_ImagePosition: object = {};

export const CardData_ImagePosition = {
  fromJSON(_: any): CardData_ImagePosition {
    const message = { ...baseCardData_ImagePosition } as CardData_ImagePosition;
    return message;
  },

  toJSON(_: CardData_ImagePosition): unknown {
    const obj: any = {};
    return obj;
  },
};

const baseCardData_BackgroundImage: object = {
  scaling: CardData_ImageScaling_Scaling.AUTO,
  position: CardData_ImagePosition_Position.CENTER,
};

export const CardData_BackgroundImage = {
  fromJSON(object: any): CardData_BackgroundImage {
    const message = {
      ...baseCardData_BackgroundImage,
    } as CardData_BackgroundImage;
    message.media =
      object.media !== undefined && object.media !== null
        ? Media.fromJSON(object.media)
        : undefined;
    message.opacity =
      object.opacity !== undefined && object.opacity !== null
        ? Number(object.opacity)
        : undefined;
    message.scaling =
      object.scaling !== undefined && object.scaling !== null
        ? cardData_ImageScaling_ScalingFromJSON(object.scaling)
        : CardData_ImageScaling_Scaling.AUTO;
    message.position =
      object.position !== undefined && object.position !== null
        ? cardData_ImagePosition_PositionFromJSON(object.position)
        : CardData_ImagePosition_Position.CENTER;
    return message;
  },

  toJSON(message: CardData_BackgroundImage): unknown {
    const obj: any = {};
    message.media !== undefined &&
      (obj.media = message.media ? Media.toJSON(message.media) : undefined);
    message.opacity !== undefined && (obj.opacity = message.opacity);
    message.scaling !== undefined &&
      (obj.scaling = cardData_ImageScaling_ScalingToJSON(message.scaling));
    message.position !== undefined &&
      (obj.position = cardData_ImagePosition_PositionToJSON(message.position));
    return obj;
  },
};

const baseCardData_Background: object = {
  type: CardData_Background_Type.COLOR,
};

export const CardData_Background = {
  fromJSON(object: any): CardData_Background {
    const message = { ...baseCardData_Background } as CardData_Background;
    message.type =
      object.type !== undefined && object.type !== null
        ? cardData_Background_TypeFromJSON(object.type)
        : CardData_Background_Type.COLOR;
    message.color =
      object.color !== undefined && object.color !== null
        ? String(object.color)
        : undefined;
    message.gradient =
      object.gradient !== undefined && object.gradient !== null
        ? Gradient.fromJSON(object.gradient)
        : undefined;
    return message;
  },

  toJSON(message: CardData_Background): unknown {
    const obj: any = {};
    message.type !== undefined &&
      (obj.type = cardData_Background_TypeToJSON(message.type));
    message.color !== undefined && (obj.color = message.color);
    message.gradient !== undefined &&
      (obj.gradient = message.gradient
        ? Gradient.toJSON(message.gradient)
        : undefined);
    return obj;
  },
};
